import { Injectable } from '@angular/core';
import { isObjectLike, map } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class LoggerStore {
  private _LOGS = {};

  getLogs() {
    return map(this._LOGS, (messages: any[][]) => {
      return messages.map((m) =>
        map(m, (v) => (isObjectLike(v) ? JSON.stringify(v) : v))
      );
    });
  }

  pushLog(...messageParts) {
    const key = Date.now();

    if (this._LOGS.hasOwnProperty(key)) {
      this._LOGS[key].push(messageParts);
    } else {
      this._LOGS[key] = [messageParts];
    }
  }
}
